export const Details = {
    title : "Let's pay rent",
    description : `You're now ready to connect with your property
    manager on ando. Make sure to take advantage of all the features
    and tools available to you as renter : Pay Rent, Check Credit Score,
    Use & Earn Rewards, Manage your account, Invite your Friends on Ando.
    `
}